var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneTabletFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone Tablet Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M6.88 5.8332C7.68541 5.8332 8.33833 6.48611 8.33833 7.29153V15.2083C8.33833 16.0137 7.68541 16.6666 6.88 16.6666H3.1263C2.32089 16.6666 1.66797 16.0137 1.66797 15.2083V7.29153C1.66797 6.48611 2.32089 5.8332 3.1263 5.8332H6.88ZM5.21148 13.7459H4.79482L4.71001 13.7517C4.40495 13.793 4.16982 14.0545 4.16982 14.3709C4.16982 14.6874 4.40495 14.9489 4.71001 14.9902L4.79482 14.9959H5.21148L5.29629 14.9902C5.60136 14.9489 5.83648 14.6874 5.83648 14.3709C5.83648 14.0545 5.60136 13.793 5.29629 13.7517L5.21148 13.7459ZM16.4591 3.33331C17.4515 3.33331 18.2638 4.10428 18.3298 5.07994L18.3341 5.20831V12.2916C18.3341 13.284 17.5631 14.0964 16.5875 14.1623L16.4591 14.1666H9.16718L9.16745 7.08331C9.16745 5.97874 8.30783 5.07495 7.22109 5.00441L7.08411 4.99998L5.01218 5.00035C5.11072 4.10733 5.8364 3.40325 6.7391 3.33822L6.87578 3.33331H16.4591ZM12.7091 11.25H10.6258C10.2806 11.25 10.0008 11.5298 10.0008 11.875C10.0008 12.1914 10.2359 12.4529 10.541 12.4943L10.6258 12.5H12.7091C13.0543 12.5 13.3341 12.2202 13.3341 11.875C13.3341 11.5586 13.099 11.2971 12.7939 11.2557L12.7091 11.25Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneTabletFilled);
export default __webpack_public_path__ + "static/media/phone-tablet-filled.84ac544580bc90ec0ecdbd572cd8a182.svg";
export { ForwardRef as ReactComponent };